<template>
    <div>
        <tab name="12">{{id}} {{activityName}}</tab>
        <el-radio-group v-model="tabList" size="small" class="MB20 MT10">
            <el-radio-button :label="1" v-if="$utils.have('/activity/thirdTicket')" >汇总</el-radio-button>
            <el-radio-button v-if="$utils.have('/activity/realName/import_channel')" :label="2">票夹门票明细</el-radio-button>
            <el-radio-button v-if="$utils.have('/activity/realName/import_channel')" :label="3">闸机门票明细</el-radio-button>
        </el-radio-group>
		
        <third-total-list v-if="tabList == 1" :id="id"></third-total-list>
        <third-ticket-list v-else-if="tabList == 2" :id="id"></third-ticket-list>
        <third-agm-list v-else-if="tabList == 3" :id="id"></third-agm-list>
    </div>
</template>

<script>
import Tab from '../components/tab';
import ThirdTotalList from './components/third-total-list'
import ThirdTicketList from './components/third-ticket-list'
import ThirdAgmList from './components/third-agm-list'
export default {
    props: {
        id: {
            type: [Number, String],
            default: null,
        },
    },
    components: { Tab,ThirdTotalList,ThirdTicketList,ThirdAgmList},
    data() {
        return {
            redirect: this.$route.query.redirect || '/activityManage/activity/list',
            dataLoading: false,
            data: null,
            activityName: '',
            tabList: 1,
			haveEditAudit: false,
			ticketNameData:[],
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        //返回
        goBack() {
            if (this.redirect) {
                this.$router.push({
                    path: this.redirect,
                });
            } else {
                this.$router.go(-1);
            }
        },
        //获取数据
        getData() {
            this.dataLoading = true;
            this.$request({
                url: "/activity/statistics/summary",
                params: { id: parseInt(this.id) },
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                        this.data = result;
                        this.activityName = result.activityName;
						
						
                    } else {
                        this.$message.error(msg || "获取信息失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("获取信息失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
      

    }

}
</script>

<style lang="scss" scoped>

</style>